<template>
	<div class="auth-info auth-info-login">
		<img :src="logoImg" alt="" class="logo-img">
		<p class="auth-title">库存100授权</p>
		<p class="auth-tip-small">请输入库存100提供的授权账号与密码</p>
		<div class="form-list">
			<span class="icon icon-phone"></span>
			<van-field v-model="formData.accound" maxlength="20" clearable placeholder="请输入账号" />
		</div>
		<div class="form-list">
			<span class="icon icon-password"></span>
			<van-field v-model="formData.password" maxlength="20" clearable placeholder="请输入密码" />
		</div>
		<bigBtn :txt="'授权'" @onBtnClick="onBtnClick"></bigBtn>
		<p class="auth-tip">PS：授权后方可对库存100订单进行操作</p>
	</div>
</template>

<script>
	import http from "@/utils/axios"; 
	import bigBtn from './bigBtn'
	import './auth.less'

	export default {
		name: "authLogin",
		components: {
			bigBtn
		},
		data () {
			return {
				formData: {
					accound: '',
					password: ''
				},
				logoImg: require('../../../assets/order/icon-logo.png')
			}
		},
		methods: {
			onBtnClick () {
				http({
					url: '/order/bees/bees/stock100/authorization',
					method: 'post',
					parmes: this.formData
				})
				.then(rps=>{
					if(rps.code == 200) {
						this.$router.push({
							name: 'authStatus',
							query: {
								statusType: 1
							}
						})
					} else {
						this.$router.push({
							name: 'authStatus',
							query: {
								statusType: 2
							}
						})
					}
				})
			}
		}
	}
</script>
